export default {
    BASE_ENDPOINT_URL: "https://taxiteslic.com/",
};
